<script setup lang="ts">
import { computed, useAttrs } from 'vue';
import { storeToRefs } from 'pinia';
import { FILTER_MESSAGES, EMPTY_MESSAGES } from '@Constants';
import { useUiStore } from '@Stores';

defineOptions({
  inheritAttrs: false,
});

const { appWidth } = storeToRefs(useUiStore());

const attrs = useAttrs();

const tooltipPosition = computed(() => ({ position: appWidth.value < 768 ? 'top' : 'left' }));

function getTranslatedValue(value: unknown, placeholder: string): string {
  //prettier-ignore
  return Array.isArray(value) 
         ? value.map((v) => v.name).join(', ') : value
         ? (value as any).name : placeholder;
}
</script>

<template>
  <FloatLabel
    v-tooltip:[tooltipPosition]="attrs.hint ? $t(attrs.hint as string) : ''"
    class="mt-2 w-full"
  >
    <Dropdown
      v-bind="{ ...attrs, FILTER_MESSAGES, EMPTY_MESSAGES }"
      pt:emptyMessage="text-sm"
      pt:filterInput="h-9 py-1 pl-3 text-xs"
      pt:input="flex h-9 items-center p-1 pl-3 pr-7 text-xs text-gray-500"
      pt:item="text-xs"
      pt:root="w-full"
      :showClear="!!attrs.modelValue && (Array.isArray(attrs.modelValue) ? attrs.modelValue.length > 0 : true)"
    >
      <template #value="slotProps">
        {{ $t(getTranslatedValue(slotProps.value, slotProps.placeholder)) }}
      </template>

      <template #option="slotProps">
        {{ $t(slotProps.option.name) }}
      </template>
    </Dropdown>

    <label
      v-if="attrs.label"
      class="-mt-2.5 flex items-center gap-2 text-sm text-zinc-500"
    >
      <div class="hidden sm:block">
        <FaIcon
          v-if="attrs.hint"
          aria-hidden
          class="size-3 text-gray-500"
          :icon="$icons.faCircleInfo"
        />
      </div>

      <span>{{ $t(attrs.label as string) }}</span>
    </label>
  </FloatLabel>
</template>
